import { student } from '../action-types';

const initialState = {
  data: null,
  studentByNis: null,
  isFetching: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case student.FETCH_STUDENT:
      return {
        ...state,
        isFetching: true,
      };
    case student.GET_STUDENT:
      return {
        ...state,
        isFetching: false,
        data: action.payload,
      };
    case student.GET_STUDENT_BY_ID:
      return {
        ...state,
        isFetching: false,
        studentByNis: action.payload,
      };
    case student.POST_STUDENT:
      return {
        ...state,
        data: {
          ...state.data,
          total_data_seluruh_siswa: state.data.total_data_seluruh_siswa + 1,
        },
      };
    default:
      return state;
  }
};
